<!-- Start What We Do Area -->
<div class="brook-what-we-do-area vertical-what-do-area bg_image--49">
    <div class="row">
        <div class="col-lg-6 col-md-12 col-12">
            <div class="creative-what-do-inner">
                <div class="inner">
                    <h1 class="heading heading-h1 font-60 line-height-1-39">Expande tu<span
                            class="theme-color"> consciencia</span> y vive mejor.</h1>
                    <div class="about-button mt--55">
                        <a class="brook-btn red-color-2 btn-sd-size btn-rounded space-between" href="/calendario"> VER EVENTOS DEL 2020
                    </a>
                    </div>

                </div>
            </div>
        </div>
        <div class="col-lg-6 col-md-12 col-12 mt_md--40 mt_sm--40">
            <div class="creative-what-do-text">
                <div class="brook-section-title mb--50">
                    <h5 class="heading heading-h5 red-color-2">Únete a nuestra comunidad</h5>
                    <div class="bkseparator--30"></div>
                    <h3 class="heading heading-h3">Aprende & Enseña</h3>
                </div>
            </div>
            <div class="creative-service-inner">
                <div class="row">

                    <!-- Start Single Service -->
                    <div class="col-lg-6 col-md-6 col-12">
                        <div class="icon-box text-left no-border bg-transparant">
                            <div class="inner">
                                <div class="icon">
                                    <img src="img/service/icon-box/home-vertical-menu-box-icon-image-01.png"
                                        alt="">
                                </div>
                                <div class="content mt--35">
                                    <h5 class="heading heading-h5">Practicantes</h5>
                                    <p class="bk_pra">La formación para practicantes es ideal para el desarrollo de la consciencia y el desarrollo personal. Te permite crecer en todos los ambitos de tu vida. </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Single Service -->

                    <!-- Start Single Service -->
                    <div class="col-lg-6 col-md-6 col-12 mt_sm--30">
                        <div class="icon-box text-left no-border bg-transparant">
                            <div class="inner">
                                <div class="icon">
                                    <img src="img/service/icon-box/home-vertical-menu-box-icon-image-02.png"
                                        alt="">
                                </div>
                                <div class="content mt--35">
                                    <h5 class="heading heading-h5">Facilitadores</h5>
                                    <p class="bk_pra">En cambio los facilitadores son preparados para capacitar y enseñar a otros. Adquieren todas las herramientas que proporciona nuestra escuela.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Single Service -->
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End What We Do Area -->

